import React, { useState, useEffect } from 'react';
import CalendarHalf from './CalendarHalf';
import changeWeekendColors from '../../scripts/changeWeekendColors'
import getPrimary from '../../scripts/getPrimary'
import getSecondary from '../../scripts/getSecondary'
import generateDatesNoArgs from '../../scripts/generateDatesNoArgs'

const Calendar = (props) => {
  const id = props.match.params.id;
  const [primary, setPrimary] = useState(getPrimary(id));
  const [secondary, setSecondary] = useState(getSecondary(id));
  const dates = generateDatesNoArgs();
  const datesQ1 = dates.splice(0, 3);
  const datesQ2 = dates.splice(0, 3);
  const datesQ3 = dates.splice(0, 3);
  const datesQ4 = dates.splice(0, 3);
  useEffect(() => {
    changeWeekendColors(primary, secondary);
  },[primary, secondary])
  return id === 'QkaQHG5U1yhPGQBa4bX3' ? (
    <div className="calendar">
      <CalendarHalf datesArray={datesQ1} rotate="rotate" />
      <CalendarHalf datesArray={datesQ2} rotate="" />
    </div>
  ) : (
    <div>
      <div className="calendar">
        <CalendarHalf datesArray={datesQ1} rotate="rotate" />
        <CalendarHalf datesArray={datesQ2} rotate="" />
      </div>
      <div className="calendar">
        <CalendarHalf datesArray={datesQ3} rotate="rotate" />
        <CalendarHalf datesArray={datesQ4} rotate="" />
      </div>
    </div>
  );
}

export default Calendar;